import type { AxiosResponse } from "axios";
import { message } from "antd";
import { useUserStore } from "@/stores/react";
import wxUtils from "@/utils/wx";
import { getBrowserEnv } from "@/utils/global";

interface NetError {
    code: string;
    i18n: string;
    field: string;
    message: string;
}

// 区域查船忽略400报错。
const urlWhitelist = ["/ship/", "/port/"];

/** React 路由尚未暴露命令式实例时，使用浏览器导航保持登录失效跳转语义。 */
const redirectToLogin = () => {
    if (typeof window !== "undefined") {
        const basePath = import.meta.env.VITE_PUBLIC_PATH || "/";
        window.location.assign(`${basePath.replace(/\/$/, "")}/login`);
    }
};

function getErrorMsg(error: NetError) {
    const whiteList = ["00000404"];

    if (!whiteList.includes(error.code)) {
        const field = error.field ? `${error.field}: ` : "";
        const code = error.code ? `${error.code}-` : "";
        const message = error.message ? `${error.message}` : "";
        console.error(field + code + message);
        return message;
    }
}

/**
 * @description: 校验网络请求状态码
 * @return void
 * @param response
 */
export const checkStatus = async (response: AxiosResponse) => {
    if (urlWhitelist.some((item: string) => new RegExp(`^${item}`).test(<string>response.config.url))) return;
    let errorMessage: string = "";
    const { status } = response;

    if (status === 400) {
        const errors = response.data?.errors;
        if (errors !== null && errors?.length > 0) {
            const errorMsgs = errors.map(getErrorMsg);
            errorMessage = errorMsgs.join("<br />");
            // console.log(msg);
        } else {
            errorMessage = response.data?.message;
        }
    } else {
        switch (status) {
            case 401: {
                useUserStore.getState().setToken("");
                if (getBrowserEnv() === 1) {
                    wxUtils.goAutoLogin();
                } else {
                    errorMessage = response.data?.message;
                    setTimeout(redirectToLogin, 50);
                    errorMessage = "登录失效！";
                }
                break;
            }
            case 403:
                errorMessage = "当前账号无权限访问！";
                break;
            case 404:
                errorMessage = "你所访问的资源不存在！";
                break;
            case 405:
                errorMessage = "请求方式错误！请您稍后重试";
                break;
            case 408:
                errorMessage = "请求超时！请您稍后重试";
                break;
            case 500:
                errorMessage = "服务异常！请联系系统管理员！";
                break;
            case 502:
                errorMessage = "网关错误！请联系系统管理员！";
                break;
            case 503:
                errorMessage = "服务不可用！请联系系统管理员！";
                break;
            case 504:
                errorMessage = "网关超时！请联系系统管理员！";
                break;
            default:
                errorMessage = "请求失败！";
        }
    }

    if (response && response.config?.responseType === "blob" && response.data instanceof Blob) {
        const blob = response.data;

        try {
            const text = await blob.text();
            const data = JSON.parse(text);

            // 推荐的提示优先级
            errorMessage = data?.errors?.[0]?.message || data?.message || "导出失败";
        } catch {
            errorMessage = "导出失败";
        }
    }

    if (errorMessage) {
        message.error(errorMessage);
    }
};
